import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { color, iconUrl } from '../styles/vars';
import {getPageMeta} from '../../../assets/components/analytics/utils';
import TrackingUtils from '../../../assets/components/fsUtils/TrackingUtils';

export const FB_ICON_CLASS_NAME = 'fbIcon';

function getUtmTerm() {
    const pageType = getPageMeta()['page_type'];
    return (pageType == 'home') ? 'homepage' : (pageType == 'section front') ? 'sf' : 'post';
}

const UTM_TERM = getUtmTerm();

function fbShareParselyTrackLink(e) {

    const trackingObject = {
        'utm_campaign'  : 'share_buttons',
        'utm_source'    : 'share_fb',
        'utm_medium'    : 'fscom',
        'utm_content'   : 'original_share',
        'utm_term'		: UTM_TERM
    };

    TrackingUtils.ParselyTrackLink(e, trackingObject);
}

function getFbShareUrl(url) {
    const utmParam =
        'utm_campaign=share_buttons&utm_medium=fscom&utm_content=return_visit&utm_term=' + UTM_TERM + '&utm_source=share_fb';
    const utmUrl = url + '?' + utmParam;

    return 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(utmUrl);
}

class FbShare extends React.Component {
	constructor(props){
		super(props);
	}

	render(){
		return (
			<a href={getFbShareUrl(this.props.url)}
			   data-url-to-track={this.props.url}
			   target="_blank"
			   onClick={fbShareParselyTrackLink}
			>
				<span className={css(styles.fbIcon)}></span>
			</a>
		);
	}

}

export default FbShare;

const styles = StyleSheet.create({
	[FB_ICON_CLASS_NAME]: {
		display: 'inline-block',
		width: '59px',
		height: '20px',
		background: `url(${iconUrl.facebookShare})`,
		backgroundSize: '100%'
	}
});



// WEBPACK FOOTER //
// ./react-app-src/shared/components/FbShare.js